<template>
    <div class="search-body" >
        <van-search
            v-model="value"
            :show-action="isCancel"
            :placeholder="placeholder"
            shape="round"
            @search="onSearch"
            :background="backgroundColor"
        />
    </div>
</template>

<script>
import {Toast} from 'vant'
import { ref, watchEffect } from '@vue/runtime-core'
import {saveHistory} from "@/views/search/SearchHistory";

export default {
    name: 'SearchBar',
    props: {
        placeholder: {
            type: String,
            default: '搜索'
        },
		typeId: {
			type: Number,
			default: 0
		},
        backgroundColor: {
            type: String,
            default: 'transparent'
        },
        isCancel: {
            type: Boolean,
            default: false
        },
        isSearch: {
            type: Boolean,
            default: false
        },
        keyword: {
            type: String,
            default: ''
        }
	},
    emits: {
        search: null
    },
    setup(props) {
        const value = ref('')

        watchEffect(
            () => value.value = props.keyword
        )

        return {
            value
        }
    },
    methods: {
        onSearch() {
            if(this.value.length <= 1) {
                Toast.fail('搜索关键词过短！请输入两个字符以上');
				return
			}
            // 保存搜索记录
            saveHistory(this.value)
            if(this.isSearch) {
                this.$emit('search', this.value)
                return
            }

            const params = {
                path: '/search/result',
                query: {
                    keyword: this.value
                }
            }
            if(this.$route.path == '/search/result') {
				this.$router.replace(params)
			}else{
				this.$router.push(params)
			}

			// const params = {
			// 	path: '/search',
			// 	query: {
			// 		keyword: this.value,
			// 		typeId: this.typeId
			// 	}
			// }
			//
			// if(this.$route.path == '/search') {
			// 	this.$router.replace(params)
			// }else{
			// 	this.$router.push(params)
			// }
        }
    }
}
</script>

<style scoped>
.search-body {
    padding: 0 5vw;
}

.van-search {
    background: none;
}
</style>

<style>
.van-search__content {
    background: #DCDCDC;
}

.van-field__control::placeholder {
    color: #B1B1B1;
}
</style>
